import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Form } from 'react-bootstrap';
import { InteractiveDiv } from '@Components/InteractiveEl';
import { useSetError } from '@src/redux/modals';
import { searchAccounts } from '../google-ads-audit-api';

interface AccountSearchPanelProps {
  mccId: string;
  onBack: () => void;
  onSelectAccount: (accountId: string, accountName: string) => void;
}

export const AccountSearchPanel = ({ mccId, onBack, onSelectAccount }: AccountSearchPanelProps) => {
  const [query, setQuery] = useState('');
  const setError = useSetError();

  const {
    data: accounts = [],
    isFetching,
    error
  } = useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['google-ads-audit-accounts', mccId, query],
    queryFn: () => searchAccounts(mccId, query || undefined)
  });

  useEffect(() => {
    if (error) {
      setError({
        title: "Couldn't search accounts",
        message: error.message,
        reportError: error
      });
    }
  }, [error, setError]);

  return (
    <div className='google-ads-audit-search-panel'>
      <InteractiveDiv className='google-ads-audit-back-link' onClick={onBack}>
        ← MCC {mccId}
      </InteractiveDiv>
      <Form.Group>
        <Form.Label>Search accounts</Form.Label>
        <Form.Control
          placeholder='Account name or ID'
          value={query}
          onChange={e => setQuery(e.target.value)}
        />
      </Form.Group>
      {isFetching && <div className='google-ads-audit-subtitle'>Searching…</div>}
      <div className='google-ads-audit-account-list'>
        {accounts.map(account => (
          <InteractiveDiv
            key={account.id}
            className='google-ads-audit-account-row'
            onClick={() => onSelectAccount(account.id, account.name)}
          >
            <span className='google-ads-audit-account-name'>{account.name}</span>
            <span className='google-ads-audit-account-id'>{account.id}</span>
          </InteractiveDiv>
        ))}
      </div>
    </div>
  );
};
